import { ApiError, apiClient } from './apiClient';

export type UserRole = 'User' | 'Manager' | 'Admin';

export interface UserProfile {
  id: string;
  email: string;
  displayName: string;
  role: UserRole;
  preferredLocale: string | null;
  photoUrl: string | null;
}

export type ProfileResult =
  | { status: 'authorized'; profile: UserProfile }
  | { status: 'access_denied'; message: string }
  | { status: 'unauthorized' };

export async function loadProfile(): Promise<ProfileResult> {
  try {
    const profile = await apiClient.get<UserProfile>('/api/auth/me');
    return { status: 'authorized', profile };
  } catch (err) {
    if (err instanceof ApiError) {
      if (err.status === 403 && err.code === 'access_denied') {
        return { status: 'access_denied', message: err.message };
      }
      if (err.status === 401) {
        return { status: 'unauthorized' };
      }
    }
    throw err;
  }
}

export function hasPermission(role: UserRole | null, required: UserRole): boolean {
  if (!role) return false;
  const rank: Record<UserRole, number> = { User: 1, Manager: 2, Admin: 3 };
  return rank[role] >= rank[required];
}
